import { useSuspenseQuery } from "@tanstack/react-query";

import { ReactQueryKeysAccount } from "services/queryKeys";

import { getPrivilegesByRole } from "./getPrivilegesByRole";

type Privilege = {
  objectType: string;
  objectName: string;
  objectCatalog?: string;
  privilegeType: string;
};

export const usePrivilegesByRole = (options: {
  roleName: string;
  catalogName?: string;
}): Privilege[] => {
  const queryKey: string[] = [
    ReactQueryKeysAccount.rolePrivileges,
    options.roleName,
    ...(options.catalogName ? [options.catalogName] : []),
  ];

  const { data } = useSuspenseQuery<Privilege[], Error>({
    queryKey,
    queryFn: () => {
      return getPrivilegesByRole(options);
    },
  });

  return data || [];
};
